import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components/macro';
import moment from 'moment';

import { IRootState } from 'reducers';

import Spinner from './Spinner';

interface IProps {
  isVisible: boolean;
}

export const Wrapper = styled.div<IProps>`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100vw;
  height: 100vh;
  justify-content: center;
  align-items: center;
  background: rgba(255, 255, 255, .8);

  display: ${({ isVisible }) => isVisible ? 'flex' : 'none'};
  flex-direction: column;
`;

const Title = styled.p`
  margin: 24px 0 0;
  max-width: 220px;
  text-align: center;
  white-space: pre-wrap;
`;

const CircularProgressTimerWrapper = styled.div`
  position: relative;
`;

const Timer = styled.span`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
`;

type Props = ReturnType<typeof mapStateToProps>;

interface IState {
  time: number | null;
  isTimerStarted: boolean;
  isTimerFinished: boolean;
}

export const BlockedScreen: React.SFC<IProps> = ({ isVisible }) => (
  <Wrapper isVisible={isVisible}>
    <Spinner
      size={140}
      spinnerColor={'#ffd800'}
      spinnerWidth={8}
      visible={true}
    />
  </Wrapper>
);

class BlockedScreenWithTimer extends React.Component<Props, IState> {
  public state = {
    time: this.props.timer,
    isTimerStarted: false,
    isTimerFinished: false,
  };

  private countdown: any;

  public componentWillReceiveProps(nextProps: any) {
    if (!nextProps.isVisible) {
      clearInterval(this.countdown);
      this.setState({
        time: null,
        isTimerStarted: false,
        isTimerFinished: false,
      });
      return;
    }

    if (typeof nextProps.timer === 'number' && !this.state.isTimerStarted) {
      this.setState({
        time: nextProps.timer,
        isTimerStarted: true,
      });

      this.countDownTimer();
    }
  }

  public countDownTimer = () => {
    this.countdown = setInterval(() => {
      this.setState(({ time, isTimerFinished }: any) => {
        if (!isTimerFinished) {
          return ({
            time: time! - 1000,
            isTimerFinished: Math.floor(time / 1000) * 1000 === 1000,
          });
        }

        clearInterval(this.countdown);
        return this.state;
      });
    }, 1000);
  };

  render() {
    const { isVisible, title } = this.props;
    return (
      <Wrapper isVisible={isVisible}>
        <CircularProgressTimerWrapper>
          <Spinner
            size={140}
            spinnerColor={'#ffd800'}
            spinnerWidth={8}
            visible={true}
          />
          {
            !this.state.isTimerFinished && this.state.time !== null && <Timer>{moment(this.state.time).format('mm:ss')}</Timer>
          }
          {
            this.state.isTimerFinished && <Timer>Время вышло</Timer>
          }
        </CircularProgressTimerWrapper>

        {
          title && <Title>{title}</Title>
        }
      </Wrapper>
    );
  }
}

const mapStateToProps = ({ app: { isUIBlocked, blockedUIMsg, blockedUITimer } }: IRootState) => ({
  isVisible: isUIBlocked,
  title: blockedUIMsg,
  timer: blockedUITimer,
});

  export default connect(mapStateToProps)(BlockedScreenWithTimer);
